module.exports = __webpack_public_path__ + "img/SetGameOptions.7411cc34.jpg";